import React from 'react';
import withSizes from 'react-sizes'
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {t} from "../../Translations";
import {mapSizesToProps} from "../../utils";
import {getLabel} from "../../App";
import Configuration from "../../Configuration";

/**
 * Class representing the detail of a vehicle
 */
class VehicleDetail extends React.Component {
    static propTypes = {
        className: PropTypes.string,

        // If provided, display the given image on top of the component
        imageSrc: PropTypes.string,
        staticimg: PropTypes.string,

        // The chosen model
        model: PropTypes.string,
        // The chosen body style
        bodyStyle: PropTypes.string,

        // The chosen commercial name
        commercialName: PropTypes.string,

        // The chosen engine
        engine: PropTypes.string,

        // The chosen transmission
        transmission: PropTypes.string,

        // The chosen rims
        rims: PropTypes.string,

        label: PropTypes.string,

        // Triggered when click on "modify" button
        onVehicleChange: PropTypes.func,

        // Whether the component is displayed on mobile or not
        isMobile: PropTypes.bool.isRequired,

        // Whether the use a tablet or not
        isTablet: PropTypes.bool
    };

    static defaultProps = {
        imageSrc: undefined,
        staticimg: undefined,
        isMobile: false,
        model: "",
        bodyStyle: "",
        commercialName: "",
        engine: "",
        transmission: "",
        rims: "",
        label: ""
    };

    componentDidMount = () => {
        window.scrollTo(0, 0);
    };

    render() {
        const {
            className,
            imageSrc,
            staticimg,
            model,
            bodyStyle,
            commercialName,
            engine,
            transmission,
            onVehicleChange,
            isMobile,
            isTablet
        } = this.props;
        const classes = classNames("col-10 col-md-12 result-car", {[className]: className !== undefined});
        const client = ("undefined" !== typeof Configuration.brand && Configuration.brand === "P" ? " ap":"");
        const detailBlockClasses = classNames({
            "col-12": (imageSrc === undefined, staticimg === undefined),
            "col-6": (imageSrc !== undefined, staticimg !== undefined),
            "step-mobile": isMobile || isTablet,
            "align-self-center" : true
        });

        return (

            (isMobile || isTablet) ? (
                <div className={classes}>
                    <div className={"row result-card card-cccu d-flex justify-content-center"+ client}>
                        {model.indexOf('<') === -1 ? (
                            <div className="col-6 align-self-center d-flex justify-content-center">
                                <img className="image-car image-car-cccu" src={imageSrc} alt=""/>
                            </div>
                        ) : (""
                        )}

                        <div className="step-mobile,col-6"
                             style={{textAlign: 'center'}}>
                            <span className="car-name car-name-cccu">{model.replace(' < 09/2018', '')}</span>
                            <span className="car-profile car-profile-cccu">{bodyStyle} {commercialName}</span>
                            <span className="car-motor car-motor-cccu">{engine} - {transmission} - {getLabel}</span>
                            <a className={"link-cccu"+client} href="change-vehicle" onClick={e => {
                                e.preventDefault();
                                onVehicleChange();
                            }}>
                                {t('Result_modify_vehicle')}
                            </a>
                        </div>
                    </div>
                </div>) : (
                <div style={{border: 1, borderStyle: 'solid'}} className={classes}>
                    <div className={"row result-card card-cccu d-flex justify-content-center"+ client}>
                        {model.indexOf('<') === -1 ? (

                            <div className="col-6 align-self-center d-flex justify-content-center">
                                <img className="image-car image-car-cccu" src={imageSrc} alt=""/>
                            </div>
                        ) : (
                            ""
                        )}

                        {model.indexOf('<') === -1 ? (

                            <div className={detailBlockClasses}>
                                <span className="car-name car-name-cccu">{model}</span>
                                <span className="car-profile car-profile-cccu">{bodyStyle} {commercialName}</span>
                                <span className="car-motor car-motor-cccu">{engine} - {transmission} - {getLabel}</span>

                                <a className={ "link-cccu"+client} href="change-vehicle" onClick={e => {
                                    e.preventDefault();
                                    onVehicleChange();
                                }}>
                                    {t('Result_modify_vehicle')}
                                </a>
                            </div>
                        ) : (
                            <div className={detailBlockClasses} style={{textAlign: 'center'}}>
                                <span className="car-name car-name-cccu">{model.replace(' < 09/2018', '')}</span>
                                <span className="car-profile car-profile-cccu">{bodyStyle} {commercialName}</span>
                                <span className="car-motor car-motor-cccu">{engine} - {transmission} - {getLabel}</span>

                                <a className={"link-cccu"+client.trim()} href="change-vehicle" onClick={e => {
                                    e.preventDefault();
                                    onVehicleChange();
                                }}>
                                    {t('Result_modify_vehicle')}
                                </a>
                            </div>
                        )}
                    </div>
                </div>

            )
        )
    }
}

export default withSizes(mapSizesToProps)(VehicleDetail);



// WEBPACK FOOTER //
// ./src/components/widgets/VehicleDetail.js